import { Box, LinearProgress, Typography } from '@mui/material';
import React, { Suspense } from 'react';
import { useApplication } from '../model/context/applicationContext';
import { XmlViewer } from '../modules/xml/xmlViewer';
import { useIntl } from 'react-intl';

const XmlViewerWrapper = () => {
  const { applicationXml } = useApplication();
  return (
    <>
      {applicationXml ? (
        <XmlViewer value={String(applicationXml)} />
      ) : (
        <Typography>Invalid Application Number</Typography>
      )}
    </>
  );
};

export const ViewXml = () => {
  const intl = useIntl();
  return (
    <Box width={1100} flexGrow={1} marginLeft={2}>
      <Suspense fallback={<LinearProgress />}>
        <Typography variant="h3" marginY={1}>
          {intl.formatMessage({ id: 'XmlFile' })}
        </Typography>
        <XmlViewerWrapper />
      </Suspense>
    </Box>
  );
};
